export default __webpack_public_path__ + "static/media/01_background.e092f25d.jpg";